var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_10875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6502 1.90137H4.95114C3.25116 1.90137 1.87305 3.17482 1.87305 4.74569V21.1006C1.87305 22.6715 3.25116 23.9449 4.95114 23.9449H22.6502C24.3502 23.9449 25.7283 22.6715 25.7283 21.1006V4.74569C25.7283 3.17482 24.3502 1.90137 22.6502 1.90137Z",
    stroke: "#FE4B4E",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_10875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9333,
    height: 24.8879,
    fill: "white",
    transform: "translate(0.333984 0.479492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.153e9be2b9554efb9b1a18509e414643.svg";
export { ForwardRef as ReactComponent };